module.exports = __webpack_public_path__ + "static/media/settings.073a0229.svg";